import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { QueryAreaComponent } from '../query-area/query-area.component';
import { Actions } from './toolbar.model';


@Component({
  selector: 'lib-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  constructor( public queraArea: QueryAreaComponent) { }

  @Output() actionEmitter = new EventEmitter<string>()  ;

  ngOnInit() {
  }

  onExecuteQuery(query: string) {
    this.actionEmitter.emit(Actions.Execute);
  }

}
